import React from "react";
import PropTypes from "prop-types";

import styles from "./collapsibleArrow.scss";

const { collapsibleArrow, arrow_down, round_arrow } = styles;

const CollapsibleArrow = ({ onClick, variant, direction }) => (
    <div
        className={`${collapsibleArrow} ${variant === "round" ? round_arrow : ""} ${direction === "down" ? `${arrow_down}` : ""}`}
        onClick={onClick}
    >
        <span></span>
    </div>
);

CollapsibleArrow.defaultProps = {
    variant: "",
    direction: "down",
}

CollapsibleArrow.propTypes = {
    onClick: PropTypes.func,
    variant: PropTypes.string,
    direction: PropTypes.string,
}


export default CollapsibleArrow;